import { Component, OnInit } from '@angular/core';
import { ConfirmationService, MenuItem } from 'primeng/api';
import { MessageService } from 'primeng/api';
import { first } from 'rxjs';
import { BankDetailService } from 'src/app/services/bank-details.service';
import { BankDetail } from './bankDetails';
import { saveAs } from 'file-saver';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';
import { ActivityRecordService } from 'src/app/services/activity-record.service';
import { AppLoaderService } from 'src/app/services/app-loader/app-loader.service';
import { IpAddressService } from 'src/app/services/ip-address.service';

@Component({
  selector: 'app-bank-details',
  templateUrl: './bank-details.component.html',
  styleUrls: ['./bank-details.component.scss'],
  providers: [BankDetailService, MessageService, ConfirmationService],
})
export class BankDetailsComponent implements OnInit {
  addBankDialog: boolean;
  fileName = 'ExcelSheet.xlsx';
  bankAccountList: BankDetail[] = [];

  bankAccount: BankDetail;

  selectedBankAccounts: BankDetail[];

  submitted: boolean;
  items: MenuItem[];

  statuses: any[];
  cols: (
    | { field: string; header: string; customExportHeader: string }
    | { field: string; header: string; customExportHeader?: undefined }
  )[];
  exportColumns: { title: string; dataKey: string }[];
  farmerId: any;
  bankList: any;
  filteredBankList: any[];
  ipAddress: any = '000.000.000';
  public loading: boolean = false;  
  constructor(
    private productService: BankDetailService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private activityRecordService : ActivityRecordService,
    private loader: AppLoaderService,
    private ipService: IpAddressService,
  ) {}

  ngOnInit() {
    this.getIP();
    this.items = [
      {
        label: 'Download excel',
        icon: 'pi pi-fw pi-download',
        command: () => {
          this.exportExcel();
        },
      },
      {
        label: 'Download Pdf',
        icon: 'pi pi-fw pi-download',
        command: () => {
          this.downloadSheetAsPdf();
        },
      },
    ];
    this.getFarmerId();
    this.getBankNameList();
    // this.getBankList();

    // this.productService.getBankDetails().subscribe(data => this.bankAccountList = data?? [])
  }

  getBankNameList() {
    this.productService.getAllBankNames().subscribe((data) => {
      if (data) {
        this.bankList = data;
        this.filteredBankList = data;
        console.log(this.bankList);
      }
    });
  }

  getFarmerId() {
    let mobile = sessionStorage.getItem('farmerPh');
    // this.loader.start();
    this.loading = true;
    this.productService.getFarmerIdByMobileNo(mobile).subscribe((resp) => {
      // this.loader.close();
      this.loading = false;
      if (resp.statusCode === 200) {
        this.activityRecordService.activityRecord(mobile, 'Bank Details', '', new Date(), 'Success');

        let far = JSON.parse(resp.data);
        if (far.length > 0) {
          this.farmerId = far[0].Farmer_ID;
          console.log(this.farmerId);

          this.getBankList();
        }
      }
      else{
        this.activityRecordService.activityRecord(mobile, 'Bank Details', '', new Date(), 'Invalid');
      }
    });
  }
  getBankList() {
     // this.loader.start();
     this.loading = true;
    this.productService
      .getBankDetails(this.farmerId)
      .pipe(first())
      .subscribe({
        next: (data) => {
          // this.loader.close();
          this.loading = false;
          let d = data ?? [];
          this.bankAccountList = d.map((res) => {
            return {
              accountHolderName: res.Account_Holder_Name,
              accountNumber: res.Account_NO,
              bankName: this.bankList
                .filter((d) => d.BANK_ID === res.Bank_ID)
                .map((d) => d.Bank_NAME)[0],
              ifscCode: res.IFSC_code,
              image: res.Passbook_Copy_Upload,
              ...res,
            };
          });
          console.log(this.bankAccountList);

          // this.messageService.add({ severity: 'success', summary: 'Success Message', detail: 'Farmer Bank Details saved Successfully.' });
        },
        error: () => {
          // this.loader.close();
          this.loading = false;
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: 'Data error! Farmer Bank Details not loaded.',
          });
        },
      });
  }

  openNew() {
    this.bankAccount = {};
    this.submitted = false;
    this.addBankDialog = true;
  }

  // deleteSelectedProducts() {
  //   this.confirmationService.confirm({
  //     message: 'Are you sure you want to delete the selected Bank Accounts?',
  //     header: 'Confirm',
  //     icon: 'pi pi-exclamation-triangle',
  //     accept: () => {
  //       this.bankAccountList = this.bankAccountList.filter(val => !this.selectedBankAccounts.includes(val));
  //       this.selectedBankAccounts = [];
  //       this.messageService.add({ severity: 'success', summary: 'Successful', detail: 'Products Deleted', life: 3000 });
  //     }
  //   });
  // }

  editProduct(bank: BankDetail) {
    console.log(bank);

    this.bankAccount = { ...bank };
    this.addBankDialog = true;
    // this.saveProduct();
  }

  // deleteProduct(bank: any) {
  //   this.confirmationService.confirm({
  //     message: 'Are you sure you want to delete ' + bank.accountHolderName + '?',
  //     header: 'Confirm',
  //     icon: 'pi pi-exclamation-triangle',
  //     accept: () => {
  //       const data = {
  //         "farmerID": bank.Farmer_ID,
  //         "bankID": bank.Bank_ID,
  //         "ifcS_Code": bank.IFSC_code,
  //         "acco_Number": +bank.Account_NO,
  //         "accHoName": bank.Account_Holder_Name,
  //         "scanCopy_Path": bank.Passbook_Copy_Upload,
  //         "active": bank.Active,
  //         "user_ID": bank.User_ID,
  //         "network_Id": bank.Network_Id,
  //         "terminal_ID": bank.Terminal_Id,
  //         "delete_Bank_record": '1'
  //       }
  //       console.log(bank);
  //       this.productService.postBankDetails(data).pipe(first())
  //     .subscribe({
  //       next: () => {
  //         this.messageService.add({ severity: 'success', summary: 'Success Message', detail: 'Bank Details Deleted Successfully.' });
  //         this.getBankList();
  //       },
  //       error: () => {
  //         this.messageService.add({ severity: 'error', summary: 'Error Message', detail: 'Data error! ' });

  //       }
  //     });

  //       // this.bankAccountList = this.bankAccountList.filter(val => val.id !== bank.id);
  //       // this.bankAccount = {};
  //       // this.messageService.add({ severity: 'success', summary: 'Successful', detail: 'Product Deleted', life: 3000 });
  //     }
  //   });
  // }

  downloadSheetAsPdf() {
    this.cols = [
      // { field: 'farmerName', header: 'Farmers Name'},
      { field: 'accountHolderName', header: 'Account Holders Name' },
      { field: 'accountNumber', header: 'Account Number' },
      { field: 'bankName', header: 'Bank Name' },
      { field: 'ifscCode', header: 'IFSC Code' },
    ];

    this.exportColumns = this.cols.map((col) => ({
      title: col.header,
      dataKey: col.field,
    }));

    import('jspdf').then((jsPDF) => {
      import('jspdf-autotable').then((x) => {
        const doc = new jsPDF.default(0, 0);
        doc.autoTable(this.exportColumns, this.bankAccountList);
        doc.save('Bank Details.pdf');
      });
    });
  }

  hideDialog() {
    this.addBankDialog = false;
    this.submitted = false;
  }

  filterBank(event: any) {
    console.log(event);

    const filtered: any[] = [];
    const query = event.query;
    for (let i = 0; i < this.bankList.length; i++) {
      const bank = this.bankList[i];
      if (bank.Bank_NAME.toLowerCase().indexOf(query.toLowerCase()) == 0) {
        filtered.push(bank);
      }
    }

    this.filteredBankList = filtered;
    console.log(this.filteredBankList);
  }

  saveProduct() {
    this.submitted = true;
    console.log(this.bankAccount);

    if (
      this.bankAccount.accountHolderName!.trim() &&
      this.bankAccount.accountNumber &&
      this.bankAccount.bankName &&
      this.bankAccount.ifscCode &&
      this.bankAccount.image
    ) {
      const data = {
        farmerID: this.farmerId,
        bankID: this.bankAccount.bankName.BANK_ID,
        ifcS_Code: this.bankAccount.ifscCode,
        acco_Number: this.bankAccount.accountNumber.toString(),
        accHoName: this.bankAccount.accountHolderName,
        scanCopy_Path: this.bankAccount.image,
        active: '1',
        user_ID: sessionStorage.getItem('abyUserID')
          ? sessionStorage.getItem('abyUserID')
          : sessionStorage.getItem('userID'),
        network_Id: this.ipAddress,
        terminal_ID: this.ipAddress,
        delete_Bank_record: '0',
      };
      // this.productService.postBankDetails(data).subscribe(res => {

      // })
      // this.messageService.add({ severity: 'success', summary: 'Successful', detail: 'Bank Details Added', life: 3000 });

      let mobile = sessionStorage.getItem('farmerPh') ? sessionStorage.getItem('farmerPh') : '';
       // this.loader.start();
    this.loading = true;
      this.productService
        .postBankDetails(data)
        .pipe(first())
        .subscribe({
          next: (resp) => {
            // this.loader.close();
            this.loading = false;
            this.activityRecordService.activityRecord(mobile, 'Bank Details Inserted', '', new Date(), resp, data);

            this.messageService.add({
              severity: 'success',
              summary: 'Success Message',
              detail: 'Bank Details Added',
            });
            this.getBankList();
          },
          error: (err) => {
            // this.loader.close();
            this.loading = false;
            this.activityRecordService.activityRecord(mobile, 'Bank Details Inserted', '', new Date(), err, data);

            this.messageService.add({
              severity: 'error',
              summary: 'Error Message',
              detail: 'Data error! Bank Details not saved.',
            });
          },
        });
      this.addBankDialog = false;
      this.bankAccount = {};
    }

    // console.log(this.bankAccountList);

    // this.bankAccountList = [...this.bankAccountList];
    // this.addBankDialog = false;
    // this.bankAccount = {};
  }

  findIndexById(id: string): number {
    let index = -1;
    for (let i = 0; i < this.bankAccountList.length; i++) {
      if (this.bankAccountList[i].id === id) {
        index = i;
        break;
      }
    }

    return index;
  }

  createId(): string {
    let id = '';
    var chars =
      'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    for (var i = 0; i < 5; i++) {
      id += chars.charAt(Math.floor(Math.random() * chars.length));
    }
    return id;
  }

  exportExcel() {
    import('xlsx').then((xlsx) => {
      let dataToSave = this.bankAccountList.map((d: BankDetail) => {
        return {
          'Account Holder Name': d.accountHolderName,
          'Account Number': d.accountNumber,
          'Bank Name': d.bankName,
          'IFSC Code': d.ifscCode,
        };
      });
      const worksheet = xlsx.utils.json_to_sheet(dataToSave);
      const workbook = { Sheets: { data: worksheet }, SheetNames: ['data'] };
      const excelBuffer: any = xlsx.write(workbook, {
        bookType: 'xlsx',
        type: 'array',
      });
      this.saveAsExcelFile(excelBuffer, 'bank_list');
    });
  }
  saveAsExcelFile(buffer: any, fileName: string): void {
    import('file-saver').then((FileSaver) => {
      let EXCEL_TYPE =
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
      let EXCEL_EXTENSION = '.xlsx';
      const data: Blob = new Blob([buffer], {
        type: EXCEL_TYPE,
      });
      saveAs(
        data,
        fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION
      );
    });
  }

  onUpload(event, formcontrol, uploadElement) {
    let file = event.files[0];
    console.log('filesss', file)
    let data = new FormData();
    data.append('file', file);
     // this.loader.start();
     this.loading = true;
    this.productService.uploadFile(data, sessionStorage.getItem('farmerPh'), formcontrol).subscribe(
      (resp: any) => {
        // this.loader.close();
        this.loading = false;
        console.log(resp);
        if (resp.statusCode == 200) {
          this.bankAccount.image = resp.data;
          this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: 'File Uploaded with Auto Mode',
          });
        }
      },
      (err) => {
        this.loader.close();
        this.messageService.add({
          severity: 'error',
          summary: 'Error Message',
          detail: err,
        });
      }
    );

    uploadElement.clear();
  }

  deleteProduct(bank: any) {
    let mobile = sessionStorage.getItem('farmerPh') ? sessionStorage.getItem('farmerPh') : '';

    this.confirmationService.confirm({
      message:
        'Are you sure you want to delete ' + bank.accountHolderName + '?',
      header: 'Confirm',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.bankAccountList = this.bankAccountList.filter(
          (val) => val.id !== bank.id
        );
        this.bankAccount = {};
        // this.messageService.add({ severity: 'success', summary: 'Successful', detail: 'Bank Deleted', life: 3000 });
        const data = {
          farmerID: bank.Farmer_ID,
          bankID: bank.Bank_ID,
          account_No: bank.Account_NO + '',
          user_ID: bank.User_ID,
          network_Id: bank.Network_Id,
          terminal_ID: bank.Terminal_Id,
        };
        console.log(bank);
         // this.loader.start();
         this.loading = true;
        this.productService
          .deleteBankDetails(data)
          .pipe(first())
          .subscribe({
            next: (resp) => {
              this.loader.close();
              this.messageService.add({
                severity: 'success',
                summary: 'Success Message',
                detail: 'Bank Details Deleted Successfully.',
              });
              this.activityRecordService.activityRecord(mobile, 'Bank Details Deleted', '', new Date(), resp, data);

              this.getBankList();
            },
            error: (err) => {
              this.loader.close();
              this.messageService.add({
                severity: 'error',
                summary: 'Error Message',
                detail: 'Data error! ',
              });
              this.activityRecordService.activityRecord(mobile, 'Bank Details Deleted', '', new Date(), err, data);

            },
          });
        // this.bankAccountList = this.bankAccountList.filter(val => val.id !== bank.id);
        // this.bankAccount = {};
        // this.messageService.add({ severity: 'success', summary: 'Successful', detail: 'Product Deleted', life: 3000 });
      },
    });
  }

  getIP() {
    this.ipService.getIPAddress().subscribe((res: any) => {
      this.ipAddress = res.ip;
    });
  }
}
